import { render, staticRenderFns } from "./TipOrder.vue?vue&type=template&id=4ebb01d8"
import script from "./TipOrder.vue?vue&type=script&lang=ts"
export * from "./TipOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports